import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/CourseCard.css';

const CourseCard = ({ course, progress }) => {
  const navigate = useNavigate();
  const pct = progress?.pct ?? 0;
  const total = progress?.total ?? 0;
  const completed = progress?.completed ?? 0;
  const isCompleted = total > 0 && completed === total;
  const started = completed > 0;

  return (
    <div className="course-card" onClick={() => navigate(`/course/${course.id}`)}>
      <div className="course-image">
        {course.imagen
          ? <img src={course.imagen} alt={course.titulo} onError={(e) => { e.target.style.display = 'none'; }} />
          : <div className="course-image-placeholder">📚</div>
        }
        <div className="course-overlay">
          <button className="see-course-btn">
            {isCompleted ? '🔄 Revisar curso' : started ? '▶ Continuar' : '▶ Comenzar'}
          </button>
        </div>
        {isCompleted && <div className="course-completed-ribbon">✅ Completado</div>}
      </div>

      <div className="course-info">
        <h3>{course.titulo}</h3>
        <p className="course-description">{course.descripcion}</p>

        <div className="course-stats">
          <span className="stat">⏱️ {course.duracion || 0}h</span>
          {total > 0 && <span className="stat">📚 {total} lecciones</span>}
        </div>

        <div className="course-progress">
          <div className="progress-bar">
            <div
              className={`progress-fill ${isCompleted ? 'complete' : ''}`}
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="progress-row">
            <span className="progress-text">
              {isCompleted
                ? '🎓 ¡Curso completado!'
                : started
                  ? `${completed}/${total} lecciones`
                  : 'Sin comenzar'}
            </span>
            <span className="progress-pct">{pct}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
